import type { Maybe, OptionalPromise } from '@adornis/base/utilTypes.js';
import type { NarrowedEntity } from '@adornis/baseql/utils/queryGeneration.js';
import type { ContractSupplementChange } from '../entities/ContractSupplement.js';

/**
 * Calls the callbacks for the given changes. The callbacks are called in the order of the changes. Sometimes it is not sufficient to check which changes are active on the supplement. This function can be used to do things if the supplement contains changes in one of the three categories. It is mainly here so i do not need to write the includes() calls in every function.
 *
 * @param changes The changes to check.
 * @param callbacks The callbacks to call.
 */
export async function changesContainPaths(
  changes: Maybe<Array<NarrowedEntity<ContractSupplementChange, { path: 1 }>>>,
  callbacks: {
    generalCallback?: () => OptionalPromise<void>;
    ag1Callback?: () => OptionalPromise<void>;
    ag2Callback?: () => OptionalPromise<void>;
  },
): Promise<void> {
  if (changes?.find(c => c.path.includes('agInfos') || c.path.includes('agSozialVersicherung'))) {
    await callbacks.generalCallback?.();
  }

  if (changes?.find(c => c.path.includes('agEingruppierung1'))) {
    await callbacks.ag1Callback?.();
  }

  if (changes?.find(c => c.path.includes('agEingruppierung2'))) {
    await callbacks.ag2Callback?.();
  }
}
